import { useEffect } from 'react';

export const useScrollToStart = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);
};
